export type SubType = 'FREE' | 'PAYED' | 'VITALYA' | 'SASHA' | 'VIP' | 'GIFTED';

export function getSubTypeName(type: SubType): string {
    return subtypeMapping.find((item) => item.type === type)?.name || 'Неизвестно';
}

export const subtypeMapping = [
    { type: 'FREE', name: 'пробная' },
    { type: 'PAYED', name: 'платная' },
    { type: 'VITALYA', name: 'для Веталя' },
    { type: 'SASHA', name: 'для Сани' },
    { type: 'VIP', name: 'VIP' },
    { type: 'GIFTED', name: 'подарочная' },
]

export interface Subscription {
    id: string;
    type: SubType;
    daysLeft: number;
    usedGb: number;
    hours: number;
}

export interface SubscriptionLink {
    link: string;
}

export interface CheckSubscriptionResult {
    hasSubscription: boolean;
    obj?: Subscription;
}